import { reject, isNil, isEmpty, anyPass } from 'ramda'
import { useIntl } from 'react-intl'

export { buildPaymentRedirectUrl } from './paymentRedirect'
export { sanitizeHtml } from './sanitizeHtml'

/**
 * Remove empty properties from object
 * @returns {Object} Returns object without Nil or Empty properties.
 */
export const removeEmptyProperties = (objectToClean: any) =>
  reject(anyPass([isEmpty, isNil]))(objectToClean)

export const getLatLng = (geoposition: string) => {
  let coords = geoposition?.split(',')

  let latitude = parseFloat(coords[0])
  let longitude = parseFloat(coords[1])

  return {
    lat: latitude,
    lng: longitude
  }
}

export const formatDate = (dateString: string) => {
  const date = new Date(dateString)

  // Get individual date and time components

  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')

  // Combine them into a formatted string
  const formattedDate = `${hours}:${minutes}`

  return formattedDate
}

/**
 * Extracts a human-readable error message from an axios error.
 * Handles DRF `{ detail: string }` (e.g. operations frozen 403),
 * legacy array bodies (`['msg1', 'msg2']`) and field-error objects.
 */
export const isTooManyRequestsError = (error: any): boolean => error?.response?.status === 429

export const getApiErrorMessage = (error: any): string | undefined => {
  const data = error?.response?.data

  if (!data) return undefined

  if (typeof data === 'string') return data

  if (Array.isArray(data)) return data.join(' ')

  if (typeof data.detail === 'string') return data.detail

  if (Array.isArray(data.detail)) return data.detail.join(' ')

  const firstField = Object.values(data).find(
    (value) => typeof value === 'string' || Array.isArray(value)
  )

  if (typeof firstField === 'string') return firstField

  if (Array.isArray(firstField)) return firstField.join(' ')

  return undefined
}

/**
 * True for values already masked (locally or by the backend) — real document
 * numbers and PESEL never contain '*'.
 */
export const isMaskedValue = (value?: string | null): boolean => !!value && value.includes('*')

/**
 * Masks a sensitive value keeping the first 2 and last 2 characters visible,
 * e.g. "77101342238" -> "77*******38". Values of 4 characters or fewer are
 * masked entirely, as showing 4 of them would reveal the whole value.
 * Values already masked by the backend are returned unchanged.
 */
export const maskSensitiveValue = (value?: string | null): string => {
  if (!value) return ''
  if (isMaskedValue(value)) return value
  if (value.length <= 4) return '*'.repeat(value.length)
  return `${value.slice(0, 2)}${'*'.repeat(value.length - 4)}${value.slice(-2)}`
}

export const GetPhotoLabel = (count: number) => {
  const { formatMessage } = useIntl()

  if (count === 1) return formatMessage({ id: 'widgetOffer.photos1', defaultMessage: 'Zdjęcie' })
  if (count > 1 && count < 5)
    return formatMessage({ id: 'widgetOffer.photos2to4', defaultMessage: 'Zdjęcia' })
  return formatMessage({ id: 'widgetOffer.photos', defaultMessage: 'Zdjęć' })
}
